import {adminLogin} from "../../../api/user/UserAccountService";
import {getMenusByUserGroup} from "../../../api/menu/MenuService";
import {getAdminMenuList} from "../../../api/field/AdminMenuService";
import {isAdmin, isSystem} from "../../../components/commonmethod/CommonMethod";

export function canConnectAsUser(viewer, target) {
    if (!viewer || !target) {
        return false;
    }
    return isSystem(viewer) || (isAdmin(viewer) && !isAdmin(target) && !isSystem(target));
}

export async function connectAsUserAccount(userAccountId) {
    try {
        const userResponse = await adminLogin(userAccountId);
        if (userResponse.status === 200) {
            localStorage.clear();

            const accessToken = userResponse.data.accessToken;
            const refreshToken = userResponse.data.refreshToken;
            localStorage.setItem("accessToken", accessToken);
            localStorage.setItem("refreshToken", refreshToken);
        }
    } catch (error) {
        if (error.response) {
            if (error.response.status === 401) {
                alert("아이디의 사용기한이 만료되었습니다. 관리자에게 문의하세요.");
            } else if (error.response.status === 423) {
                alert("비활성화된 아이디 입니다. 관리자에게 문의하세요.");
            } else if (error.response.status === 406) {
                alert("비정상적인 접근입니다. 관리자계정이 아닙니다.");
            } else {
                alert("서버와 연결할 수 없습니다. 잠시 후 다시 시도하세요.");
            }
        } else {
            alert("네트워크 오류 등 서버와 통신할 수 없습니다.");
        }
        return false;
    }

    const response = await getMenusByUserGroup();
    if (response?.status === 200) {
        localStorage.setItem("menus", JSON.stringify(response.data));
    }

    const data = await getAdminMenuList();
    if (data.status === 200) {
        const filteredData = data.data.filter((each) => each.storage === true);
        localStorage.setItem("setting", JSON.stringify(filteredData));
    }

    return true;
}
